export default function PreAnalisiSection() {
  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-[#0B1F3B] to-[#1C1C1C] rounded-2xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="p-6 sm:p-8 lg:p-10 xl:p-12">
              <div className="inline-block px-4 py-2 bg-[#E879F9]/20 backdrop-blur-sm rounded-full mb-4 sm:mb-6">
                <span className="text-sm font-semibold text-[#E879F9]">Servizio Gratuito</span>
              </div>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-5 leading-tight text-left">
                Pre-analisi Gratuita del Tuo Brand
              </h2>
              <p className="text-sm sm:text-base text-white/80 mb-6 sm:mb-8 leading-relaxed">
                Compila il questionario digitale e ricevi in 48 ore un report preliminare con la stima indicativa del valore patrimoniale del tuo marchio.
              </p>

              <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-lg text-[#22C55E]"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-semibold text-sm mb-1">Questionario guidato online (15 minuti)</h3>
                    <p className="text-white/70 text-sm">Semplice e veloce da compilare</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-lg text-[#22C55E]"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-semibold text-sm mb-1">Report automatico con stima preliminare</h3>
                    <p className="text-white/70 text-sm">Valutazione indicativa del tuo brand</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-lg text-[#22C55E]"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-semibold text-sm mb-1">Analisi KPI critici e raccomandazioni</h3>
                    <p className="text-white/70 text-sm">Suggerimenti per valorizzare il tuo marchio</p>
                  </div>
                </div>
              </div>

              <a
                href="/contatti"
                className="w-full sm:w-auto px-6 sm:px-8 py-3 bg-[#22C55E] text-white rounded-md font-semibold hover:bg-[#22C55E]/90 transition-all whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
              >
                Richiedi Pre-analisi Gratuita
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
            </div>

            <div className="relative bg-gradient-to-br from-[#E879F9]/20 to-[#22C55E]/10 p-6 sm:p-8 lg:p-10 xl:p-12 flex items-center justify-center min-h-[300px] sm:min-h-[400px]">
              <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjA1IiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-30"></div>
              
              <div className="relative z-10 text-center">
                <div className="w-20 sm:w-24 lg:w-28 h-20 sm:h-24 lg:h-28 mx-auto mb-4 sm:mb-6 bg-[#E879F9] rounded-full flex items-center justify-center">
                  <i className="ri-file-chart-line text-3xl sm:text-4xl lg:text-5xl text-white"></i>
                </div>
                <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 sm:p-5 lg:p-6 border border-white/20">
                  <div className="text-4xl sm:text-5xl font-bold text-white mb-2">48h</div>
                  <div className="text-white/80 text-sm sm:text-base">Tempo di risposta</div>
                  <div className="mt-4 sm:mt-5 pt-4 sm:pt-5 border-t border-white/20">
                    <div className="text-2xl sm:text-3xl font-bold text-[#22C55E] mb-1">100% Gratuito</div>
                    <div className="text-white/70 text-sm">Nessun impegno richiesto</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
